<template>
    <span class="badge badge-dark" style="font-size: 12.8px">
        <i class="mdi" :class="getIntensityIcon"></i>
        {{ intensity }}
    </span>
</template>

<script>
export default {
    name: "GymVideoIntensityBadge",
    props: {
        intensity: {
            type: Number,
            required: true
        },
    },
    computed: {
        getIntensityIcon() {
            let intensity = this.intensity;

            if(intensity > 0 && intensity <= 4)
                return 'mdi-speedometer-slow';
            if(intensity > 4 && intensity <= 7)
                return 'mdi-speedometer-slow';

            return 'mdi-speedometer';
        }
    }
}
</script>

<style scoped>

</style>
